/**
 * wordFile.ts
 *
 * Reads the active Word document's bytes as the original `.docx` file via the
 * shared Office.js `getFileAsync` reader (see src/shared/officeFile.ts) — the
 * same Common API the Deckorate PowerPoint tools use for PPTX. Used by the
 * Engage workflow so a created job carries the real Word document rather than a
 * plain-text export of its body (AIVA-7885).
 *
 * NOTE: like getFileAsync everywhere, this returns the LAST SAVED version of the
 * file. An unsaved document reads as empty/stale, so callers should treat a
 * failed/empty read as "nothing to attach" rather than an error.
 */

import { bytesToBase64 } from "../../../../src/shared/base64";
import { readActiveOfficeFileBytes } from "../../../../src/shared/officeFile";

export const DOCX_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

/** The active Word document's current bytes as a base64 `.docx` string. */
export async function getActiveDocumentBase64(): Promise<string> {
  const bytes = await readActiveOfficeFileBytes({
    noun: "document",
    label: "getActiveDocumentBase64",
  });
  return bytesToBase64(bytes);
}
